import Vue from 'vue';
const audienceRulesUrl = '/audience-rules';

const actionCustomError = (error) => {
  return {
    message: error,
    status: false,
  };
};

export const fetchOrganizationAudienceRules = async ({ commit }) => {
  try {
    const { data } = await Vue.axios({
      method: 'GET',
      url: audienceRulesUrl,
    });
    commit('setOrganizationAudienceRules', data);
  } catch (error) {
    return actionCustomError(error);
  }
};

/**
 * {event, prublication, benefit}
 */
export const createAudienceRules = async ({ commit }, payload) => {
  try {
    const { data } = await Vue.axios({
      method: 'POST',
      url: audienceRulesUrl,
      data: payload,
    });
    return {
      status: true,
      data: data
    }
  } catch (error) {
    return actionCustomError(error);
  }
};

export const updateAudienceRule = async ({ commit }, data) => {
  try {
    await Vue.axios({
      method: 'PATCH',
      url: audienceRulesUrl + `/${data.categoryId}`,
      data: data.payload,
    });
  } catch (error) {
    return actionCustomError(error);
  }
};

export const getAudienceRuleByCategoryId = async ({ commit }, id = null) => {
  try {
    if (!id) throw new Error('Error en el sistema');

    const { data } = await Vue.axios({
      method: 'GET',
      url: audienceRulesUrl + `/${id}`,
    });

    const extractIds = (arr) => {
      if (!Array.isArray(arr)) return [];
      return arr.map((item) => {
        if (item == null) return null;
        if (typeof item === 'string') return item;
        if (typeof item === 'object' && item._id) return String(item._id);
        return String(item);
      }).filter(Boolean);
    };

    const asDetails = (arr) => {
      if (!Array.isArray(arr)) return [];
      return arr
        .filter((item) => item && typeof item === 'object' && item._id)
        .map((item) => ({
          _id: String(item._id),
          name: item.name || item.company || String(item._id),
        }));
    };

    return {
      status: true,
      data: {
        branches: extractIds(data.branches),
        affiliationTypes: extractIds(data.affiliationTypes),
        subgroups: extractIds(data.subgroups),
        memberStatus: data.memberStatus ?? [],
        allCategories: data.allCategories || {},
        branchesDetails: asDetails(data.branches),
        affiliationTypesDetails: asDetails(data.affiliationTypes),
        subgroupsDetails: asDetails(data.subgroups),
      },
    };
  } catch (error) {
    return actionCustomError(error);
  }
};


export const sendEmailsByAudienceRule = async ({commit}, id = null) => {
  try {
    if (!id) throw new Error('Error en el sistema');

    const { data } = await Vue.axios({
      method: 'POST',
      url: audienceRulesUrl + `/send-notification/${id}`
    })

    return {
      status: true,
      data: data
    }
  } catch (error) {
    return actionCustomError(error);
  }
}

/**
 * Devuelve el conteo de miembros que verán un recurso según las reglas
 * { affiliationTypes, branches, subgroups, memberStatus }
 */
export const previewAudienceCount = async ({ commit }, rules = {}) => {
  try {
    const { data } = await Vue.axios({
      method: 'POST',
      url: audienceRulesUrl + '/preview',
      data: {
        affiliationTypes: rules.affiliationTypes || [],
        branches: rules.branches || [],
        subgroups: rules.subgroups || [],
        memberStatus: rules.memberStatus || [],
        allCategories: rules.allCategories || {},
      },
    });
    return {
      status: true,
      count: data.count ?? 0,
    };
  } catch (error) {
    return actionCustomError(error);
  }
};
